var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flyout", attrs: { id: "cartFlyout" } }, [
    _vm.isOpen
      ? _c("div", { staticClass: "backdrop", on: { click: this.hide } })
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "flyout-container", class: { open: _vm.isOpen } },
      [
        _c("div", { staticClass: "header" }, [
          _c("a", { staticClass: "close-button", on: { click: this.hide } }, [
            _c(
              "i",
              {
                staticClass: "material-icons",
                attrs: { "aria-hidden": "true" },
              },
              [_vm._v("keyboard_arrow_right")]
            ),
            _c("span", { staticClass: "sr-only sr-only-focusable" }, [
              _vm._v(_vm._s(_vm.__("Close"))),
            ]),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.__("Shopping Cart Preview"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c(
            "ul",
            { staticClass: "items" },
            _vm._l(_vm.items, function (item, key, index) {
              return _c("li", [
                _c("div", { staticClass: "item" }, [
                  _c(
                    "div",
                    {
                      staticClass: "preview-image aspect-ratio-box ratio-16-9",
                    },
                    [
                      _c("div", { staticClass: "aspect-image-container" }, [
                        _c("picture", [
                          _c("source", {
                            attrs: {
                              srcset: item.options.preview_image_webp,
                              type: "image/webp",
                            },
                          }),
                          _vm._v(" "),
                          _c("source", {
                            attrs: {
                              srcset: item.options.preview_image,
                              type: "image/jpeg",
                            },
                          }),
                          _vm._v(" "),
                          _c("img", {
                            attrs: {
                              src: item.options.preview_image,
                              width: "85",
                              alt: item.name,
                            },
                          }),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "item-name" }, [
                    _vm._v(_vm._s(item.name)),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "price" }, [
                    item.qty > 1
                      ? _c("small", { staticClass: "text-muted" }, [
                          _vm._v(
                            _vm._s(_vm.__("Quantity")) + ": " + _vm._s(item.qty)
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("strong", { staticClass: "text-nowrap" }, [
                      _vm._v(_vm._s(_vm.getItemPrice(item)) + " €"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                index === _vm.count - 1
                  ? _c("small", { staticClass: "indicator iconized" }, [
                      _c(
                        "i",
                        {
                          staticClass: "material-icons",
                          attrs: { "aria-hidden": "true" },
                        },
                        [_vm._v("check_circle")]
                      ),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.__("Successfully added"))),
                      ]),
                    ])
                  : _vm._e(),
              ])
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "footer" },
          [
            _c("div", { staticClass: "summary" }, [
              _c("span", [_vm._v(_vm._s(_vm.__("Total")))]),
              _vm._v(" "),
              _c("small", { staticClass: "x-small text-muted text-nowrap" }, [
                _vm._v(
                  _vm._s(_vm.__("including VAT")) + " " + _vm._s(_vm.vat) + "%"
                ),
              ]),
              _vm._v(" "),
              _c("small", { staticClass: "spacer" }, [_vm._v(" ")]),
              _vm._v(" "),
              _c("strong", { staticClass: "amount text-nowrap" }, [
                _vm._v(_vm._s(_vm.total) + " €"),
              ]),
            ]),
            _vm._v(" "),
            _vm._t("default"),
          ],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }